import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Select from 'react-select'
import axios from "axios";
import Departamentos from "../data/departamentos.json";
import Provincias from "../data/provincias.json";
import Distritos from "../data/distritos.json";

const ModalForm = ({ show, handleClose, downloadResource, href, image }) => {
  const [validated, setValidated] = useState(false);
  const[optionsDepartment, setOptionsDepartment] = useState([]);
  const[optionsProvince, setOptionsProvince] = useState([]);
  const[optionsDistrict, setOptionsDistrict] = useState([]);
  const [form, setform] = useState({
    name: "",
    lastName: "",
    email: "",
    phone: "",
    department: "",
    province: "",
    district: "",
    workCenter: "",
    position: "",
  });
  const saveForm = (event) => {
    event.preventDefault();
    const {
      name,
      lastName,
      email,
      phone,
      department,
      province,
      district,
      workCenter,
      position,
    } = form;
    const data = [
      name,
      lastName,
      email,
      phone,
      department,
      province,
      district,
      workCenter,
      position,
    ];
    axios
      .post(
        `https://us-central1-crypto-prism-31.cloudfunctions.net/registro-educadores/append`,
        { data }
      )
      .then((res) => {
        if (res.data && res.data.value) {
          handleClose();
        } else {
          alert("Se produjo un problema. Por favor, intentalo nuevamente.");
        }
      })
      .catch((err) => {
        console.log(err);
      });
    const formEvent = event.currentTarget;
    if (formEvent.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
    handleClose(href, downloadResource, image, true);
  };
  const handleChange = (label) => (event) => {
    setform({ ...form, [label]: event.target.value });
  };

  useEffect(() => {
    setOptionsDepartment(Departamentos.map(d => ({ value: d.id, label: d.name })))
  }, [])

  const onInputChangeDepartment = ( option ) => {
    setform({ ...form, department: option.label });
    setOptionsProvince(Provincias.filter(p => p.department_id === option.value).map(d => ({ value: d.id, label: d.name })))
  };

  const onInputChangeProvince = ( option ) => {
    setform({ ...form, province: option.label });
    setOptionsDistrict(Distritos.filter(p => p.province_id === option.value).map(d => ({ value: d.id, label: d.name })))
  };

  const onInputChangeDistrict = ( option ) => {
    setform({ ...form, district: option.label });
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>¡Queremos conocerte!</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form className="px-3 py-1" onSubmit={saveForm}>
          <p style={{fontSize: 13}} >Gracias por descargar la colección de libros "Nuestro País", tanto su versión original como las adaptadas por el Ministerio de Educación para las escuelas de primaria. Queremos aprovechar el interés en estos materiales educativos para conocerte. Le pedimos que, a través de este formulario, nos deje sus datos.</p>
          <Row className="align-items-center mt-4">
            <Col md={6} xs={12}>
              <Form.Group controlId="formBasicEmail">
                <Form.Label>Nombres </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Ingresar nombre"
                  required
                  value={form.name}
                  onChange={handleChange("name")}
                />
              </Form.Group>
            </Col>
            <Col md={6} xs={12}>
              <Form.Group controlId="formBasicEmail">
                <Form.Label>Apellidos </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Ingresar apellidos"
                  required
                  value={form.lastName}
                  onChange={handleChange("lastName")}
                />
              </Form.Group>
            </Col>

            <Col md={12} xs={12}>
              <Form.Group controlId="formBasicEmail">
                <Form.Label>Correo Electrónico</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="correo@mail.com"
                  required
                  value={form.email}
                  onChange={handleChange("email")}
                />
              </Form.Group>
            </Col>
            <Col md={12} xs={12}>
              <Form.Group controlId="formBasicEmail">
                <Form.Label>Celular </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="999999999"
                  value={form.phone}
                  onChange={handleChange("phone")}
                />
              </Form.Group>
            </Col>
            <Col md={4} xs={12}>
              <Form.Group controlId="formBasicEmail">
                <Form.Label>Departamento </Form.Label>
              
                <Select options={optionsDepartment} defaultValue={form.department} onChange={onInputChangeDepartment} placeholder="Seleccionar" />
              </Form.Group>
            </Col>
            <Col md={4} xs={12}>
              <Form.Group controlId="formBasicEmail">
                <Form.Label>Provincia </Form.Label>
                <Select options={optionsProvince} defaultValue={form.province} onChange={onInputChangeProvince} placeholder="Seleccionar" />
              </Form.Group>
            </Col>
            <Col md={4} xs={12}>
              <Form.Group controlId="formBasicEmail">
                <Form.Label>Distrito </Form.Label>
                <Select options={optionsDistrict} defaultValue={form.district} onChange={onInputChangeDistrict} placeholder="Seleccionar" />
              </Form.Group>
            </Col>
            <Col md={6} xs={12}>
              <Form.Group controlId="formBasicEmail">
                <Form.Label>Centro de trabajo </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Colegio XX | Universidad XX | Etc."
                  required
                  value={form.workCenter}
                  onChange={handleChange("workCenter")}
                />
              </Form.Group>
            </Col>
            <Col md={6} xs={12}>
              <Form.Group controlId="formBasicEmail">
                <Form.Label>Cargo </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Estudiante | Docente | Etc."
                  required
                  value={form.position}
                  onChange={handleChange("position")}
                />
              </Form.Group>
            </Col>
            <Col md={12} xs={12}>
              <Form.Group
                as={Row}
                controlId="formBasicCheckbox"
                className="mr-0 ml-0 mt-2"
              >
                <Form.Check type="checkbox" required />
                <small>
                  Al enviar este formulario, usted está aceptando nuestra{" "}
                  <a
                    href="https://fundacionmohme.org/politica-de-privacidad/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    política de privacidad
                  </a>
                  .
                </small>
              </Form.Group>
            </Col>
            <Col md={12} xs={12} className="d-flex justify-content-end mt-2">
              <Button variant="outline-primary" type="submit">
                Enviar
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ModalForm;
